import React, { useState, useMemo } from "react";
// @ts-ignore
import { TUICallKit, TUICallKitServer, TUIGlobal } from "@tencentcloud/call-uikit-react";
// import * as GenerateTestUserSig from "./debug/GenerateTestUserSig-es";


function App() {
  const [userData, setUserData] = useState({
    userID: "",
    callUserID: "",
    SDKAppID: 0,        // Replace with your SDKAppID
    SecretKey: "",      // Replace with your SecretKey
    isLogin: false,
  });
  const init = async () => {
    // const { SDKAppID, SecretKey, userID } = userData;
    // if (SDKAppID && SecretKey && userID) {
    //   try {
    //     await login(SDKAppID, SecretKey, userID);
    //     setUserData((prevState) => ({
    //       ...prevState,
    //       isLogin: true,
    //     }));
    //     alert("[TUICallKit] login success.");
    //   } catch (error) {
    //     console.error(error);
    //   }
    // } else {
    //   alert("[TUICallKit] Please fill in the SDKAppID, userID and SecretKey.");
    // }
  };
  const login = async () => {
    // const { userSig } = GenerateTestUserSig.genTestUserSig({
    //   userID: userId,
    //   SDKAppID: Number(SDKAppID),
    //   SecretKey: SecretKey,
    // });

    const userID = '0118943';
    const userSig = "eJyrVgrxCdYrSy1SslIy0jNQ0gHzM1NS80oy0zLBwgaGhhaWJsZQqeKU7MSCgswUJSsjAyAwNzaHiJdk5qYqWRmaG1qYWRgYW5pARFMrCjKLwOJGFgYGUBMy04GmOhZ5ZQSVF2Uae*V5*mjn*4cW5jslJYXnBmRVlppmhwY5BmcaeYVbZEQkJ9sq1QIAUpYwkw__";
    const SDKAppID = 20000737;
    await TUICallKitServer.init({ //【1】Initialize the TUICallKit component
      userID,
      userSig,
      SDKAppID,
    });
  };
  const call = async () => {
    await login();
    await TUICallKitServer.call({ userID: 'ex_robot5', type: 2, 
    userData: JSON.stringify({
      module: "exhibition",
      "type": "social",
      "name": "Lalia",
      "direction": "vertical"
    })
  }); //【2】Make a 1v1 video call
  };
  const callKitStyle = useMemo(() => {
    if (TUIGlobal.isPC) {
      return { width: '960px', height: '630px', margin: '0 auto' };
    }
    return { width: '100%', height: window.innerHeight };
  }, [TUIGlobal.isPC]);


  return (
    <>
      <TUICallKit style={callKitStyle}></TUICallKit>
      <div style={{ width: 350, margin: '0 auto' }}>
        <h4> {userData.isLogin ? "Call Panel" : "Login Panel"} </h4>
        <input
          value={userData.isLogin ? userData.callUserID : userData.userID}
          onChange={(value) => {
            const key = userData.isLogin ? "callUserID" : "userID";
            setUserData((prevState) => ({
              ...prevState,
              [key]: value.target.value,
            }));
          }}
          style={{ width: 230, margin: '0 auto' }}
          placeholder={
            userData.isLogin ? "Please enter callee's userID" : "Please enter your userID"
          }
        />
        <button onClick={call}> {userData.isLogin ? "call" : "login"} </button>
        <p style={{margin: '10'}}> {userData.isLogin ? `Your userID:  ${userData.userID}` : ""} </p>
      </div>
    </>
  );
}


export default App;
